module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    ref: "video",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "files"
    },
    on: {
      "change": _vm.upload
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20bf97bc"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/upvideo.vue
// module id = 479
// module chunks = 4